module.exports = __webpack_public_path__ + "img/slika24.a01e32cf.jpg";